<template>
    <div class="ppv2-bg-white dark:ppv2-bg-dark ppv2-rounded-3xl ppv2-p-6">
        <Header :title="$t('staff.title')" />
        <StaffTable :token="token" />
    </div>
</template>

<script>
import StaffTable from './StaffTable.vue'
import normalizeSize from '../../../utils/normalizeSize'
import normalizeFontSize from '../../../utils/normalizeFontSize'
import Header from '../../Shared/Header.vue'
export default {
    name: 'Staff',
    props: {
        token: { type: String, default: '' },
    },
    components: {
        StaffTable,
        Header,
    },
    methods: {
        normalizeFontSize,
        normalizeSize,
    },
}
</script>
